<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    :persistent="true"
    style="background: black;"
  >
    <v-card>
      <v-card-title>
        <span class="headline"></span>
        <v-btn
          v-if="canAddeditProjectGanttTask"
          color="primary"
          dark
          class="mb-2 ml-1 mr-1"
          @click="editingTask=null;isShowAddeditDialog=true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          icon
          dark
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <gantt-elastic
          :tasks="tasks"
          :options="options"
          style="color:black;"
        >
          <gantt-header
            slot="header"
            :options="headerOptions"
          ></gantt-header>
        </gantt-elastic>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >關閉</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

    <project-gantt-task-addedit-dialog
      v-model="isShowAddeditDialog"
      :projectId="id"
      :task="editingTask"
      @changed="onTaskAddedited"
    />

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GanttElastic from "gantt-elastic";
import GanttHeader from "gantt-elastic-header";
import ProjectGanttTaskAddeditDialog from "./project-gantt-task-addedit-dialog";
export default {
  mixins: [],
  components: {
    GanttElastic,
    ProjectGanttTaskAddeditDialog,
    GanttHeader
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    // addedit
    isShowAddeditDialog: false,
    editingTask: null,
    // ganatt
    tasks: [],
    headerOptions: {
      title: {
        label: "專案甘特圖",
        html: false
      },
      locale: {
        Now: "Now",
        "X-Scale": "寬度",
        "Y-Scale": "高度",
        "Task list width": "任務名稱欄寬",
        "Before/After": "Expand",
        "Display task list": "任務名稱"
      }
    },
    options: {
      maxRows: 100,
      maxHeight: 1000,
      title: {
        label: "Your project title as html (link or whatever...)",
        html: false
      },
      row: {
        height: 24
      },
      calendar: {
        hour: {
          display: false
        }
      },
      chart: {
        progress: {
          bar: false
        },
        expander: {
          display: true
        }
      },
      taskList: {
        expander: {
          straight: false
        },
        columns: [
          {
            id: 1,
            label: "任務",
            value: "Name",
            width: 200,
            expander: false
          },
          {
            id: 2,
            label: "操作",
            value: "-",
            width: 100,
            html: true
          }
        ]
      },
      locale: {
        name: "tw", // name String
        weekdays: "ㄧ二三四五六日".split("").map(o => `(${o})`), // weekdays Array
        weekdaysShort: "ㄧ二三四五六日".split("").map(o => `(${o})`), // OPTIONAL, short weekdays Array, use first three letters if not provided
        weekdaysMin: "ㄧ二三四五六日".split("").map(o => `(${o})`) // OPTIONAL, min weekdays Array, use first two letters if not provided
      }
      /*locale:{
          name: 'pl', // name String
          weekdays: 'Poniedziałek_Wtorek_Środa_Czwartek_Piątek_Sobota_Niedziela'.split('_'), // weekdays Array
          weekdaysShort: 'Pon_Wto_Śro_Czw_Pią_Sob_Nie'.split('_'), // OPTIONAL, short weekdays Array, use first three letters if not provided
          weekdaysMin: 'Pn_Wt_Śr_Cz_Pt_So_Ni'.split('_'), // OPTIONAL, min weekdays Array, use first two letters if not provided
          months: 'Styczeń_Luty_Marzec_Kwiecień_Maj_Czerwiec_Lipiec_Sierpień_Wrzesień_Październik_Listopad_Grudzień'.split('_'), // months Array
          monthsShort: 'Sty_Lut_Mar_Kwi_Maj_Cze_Lip_Sie_Wrz_Paź_Lis_Gru'.split('_'), // OPTIONAL, short months Array, use first three letters if not provided
          ordinal: n => `${n}`, // ordinal Function (number) => return number + output
          relativeTime: { // relative time format strings, keep %s %d as the same
            future: 'za %s', // e.g. in 2 hours, %s been replaced with 2hours
            past: '%s temu',
            s: 'kilka sekund',
            m: 'minutę',
            mm: '%d minut',
            h: 'godzinę',
            hh: '%d godzin', // e.g. 2 hours, %d been replaced with 2
            d: 'dzień',
            dd: '%d dni',
            M: 'miesiąc',
            MM: '%d miesięcy',
            y: 'rok',
            yy: '%d lat'
          }
       }*/
    }
  }),
  computed: {
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    project() {
      return this.projects.find(o => o.ID == this.id) || {};
    },
    canAddeditProjectGanttTask() {
      return this.myLevel >= 10 || this.me.ID == this.project.ManagerID;
    },
    ...mapGetters(["me", "users", "projects", "myLevel"])
  },
  methods: {
    loadTasks() {
      this.isLoading = true;

      this.$services.projectGanttTaskService
        .getByProject(this, this.id)
        .then(res => {
          this.tasks = res.data.result.map(this.processTaskToGantt);
          if (!this.tasks.length && !this.canAddeditProjectGanttTask) {
            alert('主管或專案負責人尚未安排專案甘特圖任務')
            return this.close()
          }
          this.sortTasks();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    processTaskToGantt(o) {
      o.id = o.ID;
      let beginTs = moment(o.BeginAt).unix();
      let endTs = moment(o.EndAt).unix();
      o.start = 1000 * beginTs;
      o.duration = 1000 * (endTs - beginTs + 86400);
      o.type = "milestone";
      if (o.FinishedAt) {
        o.style = {
          base: {
            fill: "#1EBC61",
            stroke: "#0EAC51"
          }
        };
      } else {
        o.style = {
          base: {
            fill: o.Color,
            stroke: o.Color,
          }
        }
      }
    
      return o;
    },
    close() {
      this.$store.state.UI.dialog.projectGantt.isShow = false;
    },
    onTaskAddedited(task) {
      let idx = this.tasks.findIndex(o => o.ID == task.ID);
      if (idx < 0) {
        this.tasks.push(this.processTaskToGantt(task));
      } else {
        this.$set(this.tasks, idx, this.processTaskToGantt(task));
      }
      this.sortTasks();
    },
    sortTasks() {
      this.tasks.sort((o1, o2) => {
        if (o1.Sorting != o2.Sorting) return o1.Sorting - o2.Sorting
        // let beginTs1 = moment(o1.BeginAt);
        // let beginTs2 = moment(o2.BeginAt);
        // if (beginTs1 != beginTs2) return beginTs1 - beginTs2;
        return o1.ID - o2.ID;
      });
    }
  },
  created() {
    window.gantt = {
      edit: ganttTaskID => {
        let task = this.tasks.find(o => o.ID == ganttTaskID);
        if (!task)
          return window.console.warn(
            `window.gantt.edit ${ganttTaskID} not found`
          );
        this.editingTask = task;
        this.isShowAddeditDialog = true;
      },
      delete: ganttTaskID => {
        let task = this.tasks.find(o => o.ID == ganttTaskID);
        if (!task)
          return window.console.warn(
            `window.gantt.edit ${ganttTaskID} not found`
          );
        if (!window.confirm(`確定刪除任務「${task.Name}」?`)) return;

        this.isLoading = true;
        this.$services.projectGanttTaskService
          .inActivate(this, ganttTaskID)
          .then(res => {
            let idx = this.tasks.findIndex(o => o.ID == ganttTaskID);
            this.tasks.splice(idx, 1);
          })
          .finally(() => (this.isLoading = false));
      },
      finish: ganttTaskID => {
        let task = this.tasks.find(o => o.ID == ganttTaskID);
        if (!task)
          return window.console.warn(
            `window.gantt.edit ${ganttTaskID} not found`
          );

        this.isLoading = true;
        this.$services.projectGanttTaskService
          .finish(this, ganttTaskID)
          .then(res => {
            task.FinishedAt = new Date().toString();
            let idx = this.tasks.findIndex(o => o.ID == ganttTaskID);
            this.$set(this.tasks, idx, this.processTaskToGantt(task));
          })
          .finally(() => (this.isLoading = false));
      }
    };
    this.options.taskList.columns[1].value = o => {
      let html = `<a href="javascript:;" onclick="window.gantt.edit(${o.ID})">編輯</a>&nbsp;<a href="javascript:;" onclick="window.gantt.delete(${o.ID})" style="color:red">刪除</a>`;
      if (!o.FinishedAt) {
        html += `&nbsp;<a href="javascript:;" onclick="window.gantt.finish(${o.ID})" style="color:green">完成</a>`;
      }
      return html;
    };
  },
  watch: {
    isShowDialog(val) {
      if (val) {
        this.loadTasks();
      }
    },
    value() {
      this.isShowDialog = this.value;
    }
  }
};
</script>

<style>
/* now button */
.gantt-elastic__header-options button:nth-child(1) {
  display: none;
}
/* expand */
.gantt-elastic__header-options label:nth-child(4) {
  display: none;
}
/* task width */
.gantt-elastic__header-options label:nth-child(5) {
  display: none;
}
/* task display */
.gantt-elastic__header-options label:nth-child(6) {
  display: none;
}
</style>
